export interface IBusinessIdentifier {
  identifierType: string;
  value: string;
}
